import React from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
const PrivateRoute = ({ children }) => {
 const token = sessionStorage.getItem('user_JWT');

 return token ? children : <Navigate to="/login" replace />;
};

PrivateRoute.propTypes = {
    children: PropTypes.any,
    
};

export default PrivateRoute;

